import type { IDeliveryAddressView } from '@model/DeliveryAddress.model';
import { SET_SELECTED_ORDER_DELIVERY_ADDRESS } from './OrderActionTypes';

export const setSelectedDeliveryAddressAction =
  (address: IDeliveryAddressView | null) => (dispatch: any) => {
    dispatch({
      type: SET_SELECTED_ORDER_DELIVERY_ADDRESS,
      payload: { address: address ?? null },
    });
  };
